import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  name: 'barLineChart',
  props: ['chart'],
  methods: {
    initBarLineChart: function initBarLineChart(data) {
      var color = data.color;
      var title = data.title;
      var xAxisData = data.xAxisData;
      var yAxisList = data.yAxisList;

      var hexToRgba = function hexToRgba(hex, opacity) {
        var rgbaColor = '';
        var reg = /^#[\da-f]{6}$/i;

        if (reg.test(hex)) {
          rgbaColor = "rgba(".concat(parseInt('0x' + hex.slice(1, 3)), ",").concat(parseInt('0x' + hex.slice(3, 5)), ",").concat(parseInt('0x' + hex.slice(5, 7)), ",").concat(opacity, ")");
        }

        return rgbaColor;
      };

      var seriesList = [];
      color.forEach(function (e, i) {
        seriesList.push({
          // name: "2018",
          name: title[i],
          type: 'line',
          smooth: true,
          symbolSize: 8,
          zlevel: 3,
          lineStyle: {
            normal: {
              color: color[i],
              shadowBlur: 3,
              shadowColor: hexToRgba(color[i], 0.5),
              shadowOffsetY: 8
            }
          },
          symbol: 'circle',
          //数据交叉点样式
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: hexToRgba(color[i], 0.3)
              }, {
                offset: 1,
                color: hexToRgba(color[i], 0.1)
              }], false),
              shadowColor: hexToRgba(color[i], 0.1),
              shadowBlur: 10
            }
          },
          data: yAxisList[i]
        });
      });
      var option = {
        backgroundColor: 'transparent',
        color: color,
        legend: {
          top: 30,
          textStyle: {
            color: '#ffffff'
          }
        },
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params) {
            var html = '';
            params.forEach(function (v) {
              html += "<div style=\"color: #666;font-size: 14px;line-height: 24px\">\n                <span style=\"display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:".concat(color[v.componentIndex], ";\"></span>\n                ").concat(v.seriesName, " ").concat(v.name, "  \n                <span style=\"color:").concat(color[v.componentIndex], ";font-weight:700;font-family: 'UnidreamLED';font-size: 18px;margin-left:5px\">").concat(v.value, "</span>\n                ").concat(data.unit);
            });
            return html;
          },
          extraCssText: 'background: #fff; border-radius: 0;box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);color: #333;',
          axisPointer: {
            type: 'shadow',
            shadowStyle: {
              color: '#0C1E31',
              shadowColor: 'rgba(255,255,255,1)',
              shadowBlur: 5
            }
          }
        },
        grid: {
          top: 100,
          height: data.height || 170,
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            formatter: '{value}',
            textStyle: {
              color: '#fff'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#D9D9D9'
            }
          },
          data: xAxisData
        }],
        yAxis: [{
          type: 'value',
          name: "".concat(data.unit),
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          },
          nameTextStyle: {
            color: '#fff',
            fontSize: 12,
            lineHeight: 40
          },
          // 分割线
          splitLine: {
            show: false,
            lineStyle: {
              type: 'dashed',
              color: '#E9E9E9'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#D9D9D9'
            }
          },
          axisTick: {
            show: false
          }
        }],
        series: seriesList
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);

      window.onresize = function () {
        myChart.resize();
      };
    }
  }
};